import { environment } from "../../../environments/environment";
import { VALID_PAGE_SIZES } from "./pagination";

const MAX_PAGE_SIZE = VALID_PAGE_SIZES.reduce((a, b) => Math.max(a, b), 0);

export const MAX_API_RESPONSE_LIMIT = 45_000;
export const ROWS_PER_PAGE = environment.production ? 15_000 - MAX_PAGE_SIZE : 5_000 - MAX_PAGE_SIZE;
export const OPERATOR_SCORES = {
  "=": 1,
  IS: 1,
  "IS NOT": 2,
  "!=": 2,
  "<>": 2,
  ">=": 3,
  ">": 3,
  "<=": 4,
  "<": 4,
  LIKE: 10,
  "NOT LIKE": 11,
};
export const REGEX_VCS_PAGE_URL =
  /^\/vcloudsmart\/(?<version>v\d+)\/(?<csp>[^/]+)\/(?<section>[^/]+)\/(?<page>[^/]+)(\/(?<tab>[^/]+))?.*$/;
export const REGEX_VCS_URL = new RegExp("^/vcloudsmart(/v[0-9]+)", "i");
export const ATTR_REGEX: RegExp = /^((?<table>Table_\d+(_[^.]+)?)\.)?(?<rest>.+)/;

// what each cloud provider calls its top-level billing/resource-ownership boundary
export const RESOURCE_COLLECTION_NAMES: { [csp: string]: string } = {
  aws: "accounts",
  gcp: "projects",
  azure: "subscriptions",
  oci: "compartments",
  drcc: "compartments",
  evo: "projects",
};

